module.exports = __webpack_public_path__ + "static/media/actinic.766eb673.svg";